import { defineMessages } from 'react-intl'

const scope = `procurify.expense.components.ExpenseTypeLabel`

export default defineMessages({
  expenseTypeOther: {
    id: `${scope}.expenseTypeOther`,
    defaultMessage: 'Other',
  },
  expenseTypeMeals: {
    id: `${scope}.expenseTypeMeals`,
    defaultMessage: 'Meals',
  },
  expenseTypeMileage: {
    id: `${scope}.expenseTypeMileage`,
    defaultMessage: 'Mileage',
  },
  expenseTypeLabour: {
    id: `${scope}.expenseTypeLabour`,
    defaultMessage: 'Labour',
  },
  expenseTypeAirfare: {
    id: `${scope}.expenseTypeAirfare`,
    defaultMessage: 'Airfare',
  },
  expenseTypeLodging: {
    id: `${scope}.expenseTypeLodging`,
    defaultMessage: 'Lodging',
  },
})
